<template>
  <ten-input-tag
    :class="_class"
    v-if="multiple"
    v-bind="$attrs"
    v-on="_listeners"
    :placeholder="_placeholder"
    :tags="value"
    :value="text"
    :get-tag-key="getValueKey"
    :get-tag-text="getValueText"
    :get-tag-closable="(...args) => !getValueDisabled(...args)"
    @blur="onBlur"
    @input="onInput"
    @focus="onFocus"
    autocomplete="off"
  >
    <template v-slot:suffixIcon>
      <slot name="suffixIcon" />
    </template>
  </ten-input-tag>
  <ten-input
    :class="_class"
    v-else
    v-bind="$attrs"
    v-on="_listeners"
    :placeholder="_placeholder"
    :value="text"
    :clearable="showClear"
    @blur="onBlur"
    @input="onInput"
    @focus="onFocus"
    @clear="onClear"
    @mouseenter="onSingleModeMouseEnter"
    @mouseleave="onSingleModeMouseLeave"
    autocomplete="off"
  >
    <template v-slot:suffixIcon>
      <slot name="suffixIcon" />
    </template>
  </ten-input>
</template>

<script>
import TenInput from './input';
import TenInputTag from './input-tag';

const name = 'ten-input-select';

export default {
  name,
  components: {
    TenInput,
    TenInputTag,
  },
  inheritAttrs: false,
  props: {
    multiple: Boolean,
    isFilteringMode: Boolean,
    placeholder: String,
    clearable: Boolean,
    value: {
      type: Array,
      default: () => [],
    },
    opened: Boolean,
    getValueKey: {
      type: Function,
      default: v => v,
    },
    getValueText: {
      type: Function,
      default: v => v,
    },
    getValueDisabled: {
      type: Function,
      default: () => false,
    },
  },
  data() {
    return {
      text: '',
      isSingleModeHovered: false,
    };
  },
  computed: {
    _class() {
      return ['ten-input-select', { 'ten-input-select--opened': this.opened }];
    },
    _placeholder() {
      if (this.multiple) return this.placeholder;
      let valueText;
      if (typeof this.value[0] !== 'undefined') {
        valueText = this.getValueText(this.value[0]);
      }
      return this.isFilteringMode && valueText ? valueText : this.placeholder;
    },
    _listeners() {
      const {
        input,
        blur,
        focus,

        ...others
      } = this.$listeners;

      return { ...others };
    },
    showClear() {
      if (this.clearable && this.isSingleModeHovered) {
        return true;
      }
      return false;
    },
  },
  watch: {
    value: {
      handler(value, oloValue) {
        if (value !== oloValue || JSON.stringify(value) !== JSON.stringify(oloValue)) {
          this.setTextFromPropValue(value);
        }
      },
      immediate: true,
    },
  },
  methods: {
    setTextFromPropValue(value) {
      if (this.isFocus && !this.$attrs.readonly && !this.$attrs.disabled) {
        return;
      }
      if (this.multiple) {
        this.text = '';
      } else {
        this.text = value[0] ? this.getValueText(value[0]) : '';
      }
    },
    clearText() {
      this.text = '';
    },
    onInput(value) {
      this.text = value;
      this.$emit('text', value);
    },
    onFocus(e) {
      this.isFocus = true;
      this.$emit('focus', e);
    },
    onBlur(e) {
      this.isFocus = false;
      setTimeout(() => {
        if (!this.isFocus) {
          this.setTextFromPropValue(this.value);
          this.$emit('blur', e);
        }
      }, 300);
    },
    onClear() {
      this.$emit('clear');
    },
    onSingleModeMouseEnter() {
      this.isSingleModeHovered = true;
    },
    onSingleModeMouseLeave() {
      this.isSingleModeHovered = false;
    },
  },
};
</script>
